<div class="flex flex-col gap-1">

  <label class="kt-form-label font-medium text-xs mb-1">

    {{ field.label }}

  </label>

  <input
    class="kt-input kt-input-sm"
    [type]="field.inputType || 'text'"
    [placeholder]="field.placeholder || ''"
    [formControl]="control"
    [readonly]="field.readonly || field.autoNumber?.readonly" />

  <mat-error *ngIf="isInvalid">

    {{ getError() }}

  </mat-error>

</div>